import SimpleLineChart from './SimpleLineChart'
export default SimpleLineChart
